// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__exCc_ Text_base__DVupc undefined","checked":"Checkbox_checked__lkDil","disabled":"Checkbox_disabled__dTK4V"};